export default __webpack_public_path__ + "static/media/muppetKlein.0c4f01f2.jpg";